export const GET_INFO='GET_INFO'
